import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-title h5 d-flex align-items-center gap-2" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id", "type", "required", "autocomplete", "aria-labelledby", "aria-invalid", "aria-describedby"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["type", "form"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalConsulte = _resolveComponent("ModalConsulte")!

  return (_openBlock(), _createBlock(_component_ModalConsulte, {
    ref: "modal",
    "modal-width": "480px",
    "z-index": "3100 !important",
    onOnClose: _ctx.aoFechar
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.icone),
          "aria-hidden": "true"
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(_ctx.pedido?.titulo), 1)
      ])
    ]),
    content: _withCtx(() => [
      (_ctx.pedido)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            id: _ctx.idFormulario,
            novalidate: "",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)), ["prevent"]))
          }, [
            _createElementVNode("p", {
              id: `${_ctx.idBase}-mensagem`,
              class: "dialogo-sistema__mensagem mb-0"
            }, _toDisplayString(_ctx.pedido.mensagem), 9, _hoisted_3),
            (_ctx.pedido.tipo === 'perguntar')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.pedido.rotulo)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: "form-label",
                        for: `${_ctx.idBase}-campo`
                      }, _toDisplayString(_ctx.pedido.rotulo), 9, _hoisted_5))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("input", {
                    id: `${_ctx.idBase}-campo`,
                    ref: "campo",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valor) = $event)),
                    type: _ctx.pedido.tipoCampo,
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.erro }]),
                    required: _ctx.pedido.obrigatorio,
                    autocomplete: _ctx.pedido.tipoCampo === 'password' ? 'current-password' : 'off',
                    "aria-labelledby": _ctx.pedido.rotulo ? undefined : `${_ctx.idBase}-mensagem`,
                    "aria-invalid": _ctx.erro ? 'true' : undefined,
                    "aria-describedby": _ctx.erro ? `${_ctx.idBase}-erro` : undefined
                  }, null, 10, _hoisted_6), [
                    [_vModelDynamic, _ctx.valor]
                  ]),
                  (_ctx.erro)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        id: `${_ctx.idBase}-erro`,
                        class: "invalid-feedback d-block",
                        role: "alert"
                      }, _toDisplayString(_ctx.erro), 9, _hoisted_7))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 40, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(() => [
      (_ctx.pedido)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.pedido.tipo !== 'avisar')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-light",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelar && _ctx.cancelar(...args)))
                }, _toDisplayString(_ctx.pedido.textoCancelar), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: _ctx.pedido.tipo === 'perguntar' ? 'submit' : 'button',
              form: _ctx.pedido.tipo === 'perguntar' ? _ctx.idFormulario : undefined,
              class: _normalizeClass(["btn", _ctx.pedido.perigo ? 'btn-danger' : 'btn-primary']),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pedido.tipo === 'perguntar' ? undefined : _ctx.confirmar()))
            }, _toDisplayString(_ctx.pedido.textoConfirmar), 11, _hoisted_8)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}